import Icon from '../components/Icon.vue';
Icon.register({
  'external-link-alt': {
    width: 512,
    height: 512,
    paths: [{
      d: 'M432 320c8.8 0 16 7.2 16 16v128c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-144v320h320v-112c0-8.8 7.2-16 16-16h32zM488 0c13.2 0 24 10.8 24 24v128c0 21.5-26 32-41 17l-35.7-35.7-243.6 243.7c-4.3 4.4-10.4 7.1-17 7.1s-12.7-2.7-17-7.1l-22.7-22.6c-4.4-4.3-7.1-10.4-7.1-17 0-6.6 2.7-12.7 7.1-17l243.7-243.6-35.7-35.7c-15-15.1-4.4-41 17-41h128z'
    }]
  }
});